<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  publicHelpUrl: { type: String, default: '' },
});

const emit = defineEmits(['close', 'create-chat']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Suporte TP/CX"
    max-width-class="max-w-[560px]"
    full-screen
    @close="emit('close')"
  >
    <div
      v-if="errorMessage"
      class="grid min-h-[260px] place-items-center text-center"
    >
      <div class="max-w-[360px]">
        <span
          class="i-lucide-circle-alert mx-auto block size-11 text-rose-600"
          aria-hidden="true"
        />
        <h3 class="mt-4 text-[18px] font-semibold text-lais-text">
          Não foi possível abrir o suporte
        </h3>
        <p class="mt-2 text-[13px] leading-relaxed text-lais-text-body">
          {{ errorMessage }}
        </p>
      </div>
    </div>
    <div v-else class="grid gap-4">
      <div
        class="rounded-lais border border-lais-primary/20 bg-lais-primary-50/40 p-4"
      >
        <p class="text-[12px] font-semibold uppercase text-lais-primary">
          Atendimento operacional
        </p>
        <h3 class="mt-1 text-[18px] font-semibold text-lais-text">
          Fale com o time de suporte
        </h3>
        <p class="mt-2 text-[13px] leading-relaxed text-lais-text-body">
          Use este atalho para abrir uma conversa TP/CX quando precisar de apoio
          em anúncio, visita, proposta ou encaminhamento operacional.
        </p>
      </div>
      <div class="grid gap-3 sm:grid-cols-2">
        <article class="rounded-lais border border-lais-border bg-white p-4">
          <p class="font-semibold text-lais-text">Tenant Prospect</p>
          <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
            Dúvidas do interessado sobre anúncio, visita, valores ou imóveis
            similares.
          </p>
        </article>
        <article class="rounded-lais border border-lais-border bg-white p-4">
          <p class="font-semibold text-lais-text">Customer Experience</p>
          <p class="mt-1 text-[12px] leading-5 text-lais-text-muted">
            Apoio para jornada do cliente, visitas de amanhã e contexto de
            relacionamento.
          </p>
        </article>
      </div>
    </div>

    <template #footer>
      <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
        <LaisPrimaryButton variant="ghost" @click="emit('close')">
          Fechar
        </LaisPrimaryButton>
        <a
          v-if="publicHelpUrl"
          :href="publicHelpUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center justify-center gap-2 rounded-lais border border-lais-border bg-white px-4 py-2.5 text-[14px] font-semibold text-lais-text hover:border-lais-primary"
        >
          <span class="i-lucide-external-link size-4" aria-hidden="true" />
          Central pública
        </a>
        <LaisPrimaryButton
          icon="i-lucide-message-circle"
          @click="emit('create-chat')"
        >
          Criar chat
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
